<template>
  <div class="web-panel-user-dropdown relative">
    <UIButton
      unstyled
      class="dropdownbtn f-body b flex items-center h-100 dib"
      @click="openDropdown"
    >
      <div class="namestatus mr3">
        <span class="name">{{ user.name }}</span>
        <span class="status" v-if="$store.getters.isTenant">{{ $t('Global Admin Mode') }}</span>
      </div>
      <UIIcon name="chevron-down" />
    </UIButton>
    <transition name="dropdown">
      <div class="dropdowncontent" v-show="isDropdownOpen">
        <ul>
          <li class v-for="option in dropdownItems" :key="option.name" @click="closeDropdown">
            <ClickArea
              v-on="$listeners"
              v-bind="$attrs"
              :item="option"
              class="f-body"
            >{{ option.name }}</ClickArea>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import UIIcon from '@sbvr/common/legacy-shared/components/ui/UIIcon';
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton';
import { ref, watch } from '@vue/composition-api';
import { setupClickOutside } from '@sbvr/common/legacy-shared/helpers/handleClickOutside';
import ClickArea from '@sbvr/component-helpers/ClickArea';

export default {
  components: {
    UIIcon,
    UIButton,
    ClickArea,
  },
  props: {
    user: {
      required: true,
    },
    dropdownItems: {
      type: Array,
      default: () => ([
        {
          name: 'User Settings',
          routerLink: { name: 'user-settings' },
        },
      ]),
    },
  },
  setup () {
    const isDropdownOpen = ref(false);
    function openDropdown () {
      isDropdownOpen.value = true;
    }
    function closeDropdown () {
      isDropdownOpen.value = false;
    }
    let teardown;
    watch(() => isDropdownOpen.value, async () => {
      if (isDropdownOpen.value) {
        teardown && teardown();
        setImmediate(() => {
          teardown = setupClickOutside('.web-panel-user-dropdown .dropdowncontent', () => {
            isDropdownOpen.value = false;
          });
        });
      }
    });
    return {
      isDropdownOpen,
      openDropdown,
      closeDropdown,
    };
  },
};
</script>

<style lang="postcss" scoped>
.web-panel-user-dropdown {
  & .dropdownbtn {
    padding: 0 1rem 0 2rem;
    margin-right: 1rem;
  }
  & .name {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 8rem;

    @media (--tablet) {
      max-width: 100%;
    }
  }
  & .dropdowncontent {
    box-shadow: var(--dropShadow);

    position: absolute;
    top: calc(100% + 1.7rem);
    right: 0;
    /* right: calc(-1 * var(--spacingSm)); */
    width: 100vw;
    min-height: 100vh;
    background-color: white;
    transform-origin: top center;
    transition: transform 0.15s ease 0.15s, opacity 0.15s ease 0.15s;
    will-change: transform, opacity;
    z-index: -1;

    @media (--tablet) {
      right: 0;
      max-width: 20rem;
      min-height: auto;
    }

    & ul {
      padding-left: 0;
      list-style-type: none;
      margin: 0;
      overflow: hidden;

      & li {
        margin: 0;
        padding: var(--spacingSm);
        background-color: white;
        cursor: pointer;
        transform: translateZ(0);
        will-change: opacity;
        transition: opacity 0.15s ease;
        position: relative;
        min-height: 5rem;

        & a {
          text-decoration: none;
          color: var(--colorDarkest);
          display: block;
          position: absolute;
          padding: var(--spacingSm);
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        &:hover {
          background-color: var(--colorLightest);
        }
      }
    }
  }
  & .dropdown-enter,
  & .dropdown-leave-to {
    @media (--tablet) {
      transform: scaleY(0) translateZ(0);
    }
    opacity: 0;
    & li {
      opacity: 0;
      transform: translateZ(0);
    }
  }
  & .dropdown-enter-to,
  & .dropdown-leave {
    transform: scale(1) translateZ(0);
    opacity: 1;
    & li {
      opacity: 1;
      transform: translateZ(0);
    }
  }
  /* display: flex;
    align-items: center;
    flex: 0 0 auto;
    max-width: 11rem;

    @media (--tablet) {
      max-width: 100%;
    }

    & .notification {
      position: relative;
      margin-right: var(--spacingSm);

      & .notification-icon {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0.2rem solid var(--colorLightGrey);
        border-radius: 50%;
        cursor: pointer;

        & svg {
          stroke: var(--colorManatee);
          width: 1rem;
          height: 1rem;
        }
      }

      @media (--tablet) {
        margin-right: var(--spacingMd);

        & .notification-item {
          width: 3rem;
          height: 3rem;

          & svg {
            width: 1.75rem;
            heigth: 1.75rem;
          }
        }
      }
    }

    & .user {
      position: relative;

      & .avatar-and-name {
        display: flex;
        align-items: center;
        cursor: pointer;

        & .name {
          @apply --f4;

          display: block;
          overflow-x: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 8rem;

          @media (--tablet) {
            max-width: 100%;
          }
        }

        & .status {
          @apply --f6;

          display: none;

          @media (--tablet) {
            display: block;
          }
        }

        & svg {
          width: 1.5rem;
          height: 1.5rem;
          margin-left: var(--spacingSm);
        }
      }

    } */
}
</style>
